const SET_PROJECT_DEMAND_GRAPHIC = '@account/set-project-demand-graphic';
const REFRESH = '@account/refresh';

const setProjectDemandGraphic = (projectDemandGraphic) => (dispatch) => dispatch({
  type: SET_PROJECT_DEMAND_GRAPHIC,
  payload: {
    projectDemandGraphic,
  },
});

const refresh = () => (dispatch) => dispatch({
  type: REFRESH,
});

export default {
  setProjectDemandGraphic,
  SET_PROJECT_DEMAND_GRAPHIC,
  refresh,
  REFRESH,
};
